var _defs, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133.69 183.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fa0f00;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.31 0 133.69 0 133.69 118.23 84.31 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.52 0 0.1 0 0.1 118.23 49.52 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.92 43.57 98.38 118.23 77.76 118.23 68.35 94.45 45.32 94.45 66.92 43.57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,178.35l-2.17,10.28c-.07.4-.2.46-.53.46H6c-.4,0-.53-.13-.46-.66l8.63-37.23a13.61,13.61,0,0,0,.26-3.62.36.36,0,0,1,.4-.4h9c.33,0,.46.14.53.47l10.08,40.91c.07.4-.07.53-.4.53h-7a.47.47,0,0,1-.53-.46l-2.3-10.28Zm7.84-7c-.92-4.81-2.63-12.06-3.29-16.74h-.07c-.66,4.55-1.91,10.94-3,16.74Z",
    transform: "translate(-5.56 -5.66)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.54,173.08c0-9.5,5.6-16.86,14.51-16.86h1V145c0-.2.13-.33.39-.33h7c.26,0,.32.13.32.33v37.49a29.32,29.32,0,0,0,.2,4.36.4.4,0,0,1-.26.45,21.45,21.45,0,0,1-9.44,2.28C41.07,189.61,35.54,184.28,35.54,173.08Zm15.55-9.89a3.46,3.46,0,0,0-1.43-.2c-3.64,0-6.38,3.32-6.38,9.83,0,6.9,2.74,9.76,6.32,9.76a5.53,5.53,0,0,0,1.49-.19Z",
    transform: "translate(-5.56 -5.66)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.63,172.82c0,10.28-4.3,16.79-11.85,16.79-8.46,0-11.84-7.42-11.84-16.86,0-9.63,4.3-16.53,12-16.53C82.27,156.22,86.63,162.34,86.63,172.82Zm-16.08,0c0,6.05,1.31,10,4.23,10s4.17-3.38,4.17-10c0-6.12-1-9.9-4.1-9.9C72.18,163,70.55,166.05,70.55,172.82Z",
    transform: "translate(-5.56 -5.66)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.08,144.7c.26,0,.33.13.33.39v11.52a16.26,16.26,0,0,1,3.51-.39c6.77,0,11.91,5.21,11.91,15.3,0,11.78-6.7,18.09-15.09,18.09a24.39,24.39,0,0,1-7.55-1.17.56.56,0,0,1-.4-.52V145.09a.35.35,0,0,1,.4-.39Zm2.67,18.42a8.11,8.11,0,0,0-2.34.33v19.2a5.38,5.38,0,0,0,1.37.13c2.93,0,6.37-3,6.44-11.07C106.28,165.4,103.75,163.12,100.75,163.12Z",
    transform: "translate(-5.56 -5.66)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.38,174.71c0,5,1.88,8.07,7.16,8.07a13.27,13.27,0,0,0,4.94-.91c.33-.13.52-.13.52.32v5.4c0,.46-.13.72-.45.85a14.19,14.19,0,0,1-6.45,1.17c-9.56,0-13.27-7-13.27-16.2,0-9.77,4.29-17.19,11.91-17.19,8,0,10.35,7.1,10.35,12.89a35.29,35.29,0,0,1-.33,4.88.61.61,0,0,1-.58.52c-.66.07-2.67.2-6.19.2Zm5.53-6.12a9.91,9.91,0,0,0,2-.07,2.66,2.66,0,0,0,.07-.71c0-2.47-.78-5.08-3.45-5.08s-3.65,2.67-4,5.86Z",
    transform: "translate(-5.56 -5.66)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobe);
export default __webpack_public_path__ + "static/media/adobe.1ed1d96016c195fa7432a6a59fa58c95.svg";
export { ForwardRef as ReactComponent };